import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  PROJECTS_COLLECTION,
  JOBS_COLLECTION,
  EDUCATION_COLLECTION,
  SKILLS_COLLECTION,
  TOOLS_COLLECTION,
  COMPANIES_COLLECTION,
} from '@dges/modules/portfolio/domain';
import { ProjectsCollectionService } from './projects-collection.service';
import { JobsCollectionService } from './jobs-collection.service';
import { EducationCollectionService } from './education-collection.service';
import { SkillsCollectionService } from './skills-collection.service';
import { ToolsCollectionService } from './tools-collection.service';
import { CompaniesCollectionService } from './companies-collection.service';

/**
 * Binds every portfolio collection contract to its Firebase implementation.
 * Call once at the app composition root.
 */
export function providePortfolioFirebaseApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: PROJECTS_COLLECTION, useExisting: ProjectsCollectionService },
    { provide: JOBS_COLLECTION, useExisting: JobsCollectionService },
    { provide: EDUCATION_COLLECTION, useExisting: EducationCollectionService },
    { provide: SKILLS_COLLECTION, useExisting: SkillsCollectionService },
    { provide: TOOLS_COLLECTION, useExisting: ToolsCollectionService },
    { provide: COMPANIES_COLLECTION, useExisting: CompaniesCollectionService },
  ]);
}
